var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "shop-tile global-material-tile" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-3 col-md-4 col-lg-3" }, [
        _c(
          "div",
          {
            staticClass: "tile--image-wrapper",
            staticStyle: { position: "relative" },
          },
          [
            _c(
              _vm.tile.detail_link ? "a" : "span",
              {
                tag: "component",
                staticClass: "tile--link",
                attrs: { href: _vm.tile.detail_link },
                on: { click: _vm.onLinkClick },
              },
              [
                _c("img", {
                  staticClass: "tile--image img-fluid",
                  attrs: {
                    title: _vm.tile.title,
                    src: _vm.tile.image_src,
                    alt: _vm.tile.title,
                  },
                }),
              ]
            ),
            _vm._v(" "),
            _vm._t("button-add2wishlist"),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-9 col-md-8 col-lg-9 tile-content-wrapper" },
        [
          _c(
            "div",
            { staticClass: "tile-content" },
            [
              _c(
                _vm.tile.detail_link ? "a" : "span",
                {
                  tag: "component",
                  staticClass: "tile--link",
                  attrs: { href: _vm.tile.detail_link },
                  on: { click: _vm.onLinkClick },
                },
                [
                  _c("p", { staticClass: "tile--title" }, [
                    _c("strong", [_vm._v(_vm._s(_vm.tile.title))]),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "tile--subtitle" }, [
                    _vm._v(_vm._s(_vm.tile.subtitle)),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "tile--subtitle" }, [
                    _vm._v(_vm._s(_vm.tile.subsubtitle)),
                  ]),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm._t("button-area"),
          _vm._v(" "),
          _vm._t("remove-button"),
          _vm._v(" "),
          _vm.$slots.ordercount
            ? _c(
                "div",
                { staticClass: "button-wrapper spacer--top-small" },
                [_vm._t("ordercount")],
                2
              )
            : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }